import { LayoutCentered } from "components/common/layout/centered/LayoutCentered";
import { Wrapper } from "components/common/utils/wrapper/Wrapper";
import LoginForm from "pages/auth/login/components/login-form/LoginForm";
import React, { Component } from "react";
import { fetchGraphQL } from 'services/graphql/GraphQL';

/**
 * Login component.
 */
export class LoginPage extends Component {

  public componentDidMount() {
    const url = window.location.href;
    const urlItems = url.split('/')
    const subdomain = urlItems[2].split('.')[0];

    if (subdomain !== 'platform'
      && subdomain !== 'test'
      && subdomain !== 'localhost:3000') {
      // general link
      fetchGraphQL(`
        query {
          url {
            getLinkBySubdomain(subdomain:"${subdomain}") 
          }
        }
        `).then(res => {
        if (res && res.url && res.url.getLinkBySubdomain) {
          window.location.href = 'https://platform.isotopeticketing.com' + res.url.getLinkBySubdomain
        }
      })
    }
  }

  public render() {
    return (
      <div>
        <LayoutCentered >
          <Wrapper maxWidth={"700px"} >
            <LoginForm />
          </Wrapper>
        </LayoutCentered>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/login/Login.page.tsx